<div
  class="auth"
  style="
    background-image: url(../../../assets/images/originals/bg9.jpg);
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center center;
    min-height: 100vh;
    flex-direction: column;
    margin: 0;
    overflow-y: hidden;
  "
>
  <div class="row d-flex justify-content-center g-0">
    <div class="d-none d-lg-block col-lg-4 login-sidebar px-5">
      <div class="slider-light">
        <div
          class="position-relative h-100 d-flex justify-content-center align-items-center"
        >
          <div class="slide-img-bg"></div>
          <div class="slider-content text-light pt-5">
            <h3>{{ "Form.THANK_YOU_TITLE" | translate }}</h3>
            <p>
              {{ "Form.Login.ARCHITECTURE_INFO_MESSAGE" | translate }}
            </p>
            <div>
              <ul>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT1HEADING" | translate }}</strong>
                  {{ "Form.Login.Point1" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT2HEADING" | translate }}</strong>
                  {{ "Form.Login.Point2" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT3HEADING" | translate }}</strong>
                  {{ "Form.Login.Point3" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT4HEADING" | translate }}</strong>
                  {{ "Form.Login.Point4" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center col-md-12 col-lg-8 pt-5"
    >
      <div class="mx-auto app-login-box col-md-6 card p-5">
        <h4 class="mb-0 text-center">
          <img src="../../../assets/images/logo-blue.png" width="200" />
        </h4>

        <div class="pt-5">
          <form [formGroup]="registerForm" class="needs-validation">
            <div>
              <div
                id="exampleInputGroup1"
                role="group"
                class="form-group mb-4 d-flex flex-wrap"
              >
                <div class="d-flex flex-wrap align-items-center">
                  <label for="email" style="width: 100px">{{
                    "Form.Login.USER" | translate
                  }}</label>
                  <div style="width: 250px">
                    <input
                      formControlName="email"
                      name="email"
                      id="email_id"
                      type="text"
                      placeholder="{{ 'Form.Placeholder.EMAIL' | translate }} "
                      required="required"
                      aria-required="true"
                      class="form-control"
                      required
                    />
                    <div
                      *ngIf="submitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.required">
                        {{ "Form.Login.PLEASE_ENTER_EMAILID" | translate }}
                      </div>
                      <div *ngIf="f.email.errors.email">
                        {{ "Form.Error.InvalidEmail" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="exampleInputGroup2" role="group" class="form-group">
                <div class="d-flex flex-wrap align-items-center">
                  <label for="password" style="width: 100px">{{
                    "Form.Login.PASSWORD" | translate
                  }}</label>
                  <div style="width: 250px">
                    <input
                      formControlName="password"
                      name="password"
                      id="password_id"
                      placeholder="{{
                        'Form.Placeholder.PASSWORD' | translate
                      }}"
                      type="password"
                      class="form-control"
                      required
                    />
                    <div
                      *ngIf="submitted && f.password.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.password.errors.required">
                        {{ "Form.Login.PLEASE_ENTER_PASSWORD" | translate }}
                      </div>
                      <div *ngIf="f.password.errors.minlength">
                        {{ "Form.Error.PASSWORDError" | translate }}
                      </div>
                      <div *ngIf="f.password.errors.pattern">
                        {{ "Form.Error.InavlidPass" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <a
                  [routerLink]="['/forgot-password']"
                  class="btn-link col-md-6 mt-3 mb-3 text-start"
                  >{{ "Form.Login.RECOVER_PASSWORD" | translate }}</a
                >
              </div>

              <div
                class="modal-footer row clearfix me-2"
                style="padding-left: 0; margin-left: 0"
              >
                <div class="row" style="padding-left: 0; margin-left: 0">
                  <div class="col-md-6 p-0">
                    <button
                      type="submit"
                      class="btn btn-purple btn-lg w-100 me-2"
                      (click)="onSubmit()"
                    >
                      {{ "Form.Login.SIGN_IN" | translate }}
                    </button>
                  </div>
                  <div class="col-md-6 p-0">
                    <h6>
                      <a
                        [routerLink]="['/company-registration']"
                        class="btn btn-link btn-lg w-100 text-start"
                        >{{ "Form.Login.SIGN_UP_NOW" | translate }}</a
                      >
                    </h6>
                  </div>
                </div>
              </div>
              <div style="font-size: 14px">
                By logging in, you agree to TheAppSherpa's
                <a
                  href="https://theappsherpa.com/terms-conditions/"
                  target="_blank"
                  >Terms of Use</a
                >
                and
                <a
                  href="https://theappsherpa.com/privacy-policy/"
                  target="_blank"
                  >Privacy Policy</a
                >.
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
